import { v4 as uuidv4 } from 'uuid';

/**
 * Generates a UUID v4 string.
 *
 * Uses crypto.randomUUID() when available (requires HTTPS or localhost),
 * falls back to uuid library for older browsers or non-secure contexts.
 */
export function generateUUID(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // crypto.randomUUID() can throw in non-secure contexts
  }
  return uuidv4();
}
